var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{ref:"toastuiEditor",attrs:{"initialValue":_vm.editorText,"height":"400px","initialEditType":"wysiwyg","previewStyle":"vertical"},on:{"change":_vm.onUpdateEditor}})
}
var staticRenderFns = []

export { render, staticRenderFns }